import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "data-panel" }
const _hoisted_2 = {
  key: 0,
  class: "ia-pricing-note"
}
const _hoisted_3 = {
  key: 1,
  style: {"color":"#6b7280","font-size":"14px","margin":"16px 0"}
}
const _hoisted_4 = {
  key: 2,
  style: {"color":"#9ca3af","font-size":"14px","margin":"16px 0"}
}
const _hoisted_5 = { class: "ia-stats-grid" }
const _hoisted_6 = { class: "ia-stat-card ia-stat-card--cost" }
const _hoisted_7 = { class: "ia-stat-value" }
const _hoisted_8 = { class: "ia-stat-card ia-stat-card--cost" }
const _hoisted_9 = { class: "ia-stat-value" }
const _hoisted_10 = { class: "ia-stat-card" }
const _hoisted_11 = { class: "ia-stat-value" }
const _hoisted_12 = { class: "ia-stat-card" }
const _hoisted_13 = { class: "ia-stat-value" }
const _hoisted_14 = { class: "ia-stat-card" }
const _hoisted_15 = { class: "ia-stat-value" }
const _hoisted_16 = { class: "ia-stat-card" }
const _hoisted_17 = { class: "ia-stat-value" }
const _hoisted_18 = {
  key: 0,
  style: {"color":"#9ca3af","font-size":"14px"}
}
const _hoisted_19 = {
  key: 1,
  class: "ia-resource-list"
}
const _hoisted_20 = { class: "ia-resource-head" }
const _hoisted_21 = { class: "ia-resource-label" }
const _hoisted_22 = { class: "ia-resource-cost" }
const _hoisted_23 = { class: "ia-resource-pct" }
const _hoisted_24 = { class: "ia-resource-bar-wrap" }
const _hoisted_25 = { class: "ia-resource-meta" }
const _hoisted_26 = { key: 0 }
const _hoisted_27 = {
  key: 2,
  style: {"color":"#9ca3af","font-size":"14px"}
}
const _hoisted_28 = {
  key: 3,
  class: "log-scroll"
}
const _hoisted_29 = { class: "admin-table" }
const _hoisted_30 = {
  key: 4,
  style: {"color":"#9ca3af","font-size":"14px"}
}
const _hoisted_31 = {
  key: 5,
  class: "log-scroll"
}
const _hoisted_32 = { class: "admin-table" }
const _hoisted_33 = ["title"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[11] || (_cache[11] = _createElementVNode("h3", { class: "data-title" }, "Consumo de IA", -1)),
    ($setup.iaUsage?.pricing)
      ? (_openBlock(), _createElementBlock("p", _hoisted_2, " Preços: " + _toDisplayString($setup.iaUsage.pricing.model) + " · $" + _toDisplayString($setup.iaUsage.pricing.inputPerM.toFixed(2)) + "/1M tokens entrada · $" + _toDisplayString($setup.iaUsage.pricing.outputPerM.toFixed(2)) + "/1M tokens saída ", 1))
      : _createCommentVNode("", true),
    ($setup.iaUsageLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, "Carregando..."))
      : (!$setup.iaUsage)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, "Nenhum dado de IA disponível."))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("span", _hoisted_7, _toDisplayString($setup.formatCost($setup.iaUsage.estimatedCostUsd)), 1),
                _cache[0] || (_cache[0] = _createElementVNode("span", { class: "ia-stat-label" }, "Custo total estimado", -1))
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("span", _hoisted_9, _toDisplayString($setup.formatCost($setup.iaUsage.last30CostUsd)), 1),
                _cache[1] || (_cache[1] = _createElementVNode("span", { class: "ia-stat-label" }, "Custo últimos 30 dias", -1))
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("span", _hoisted_11, _toDisplayString($setup.iaUsage.totalRequests), 1),
                _cache[2] || (_cache[2] = _createElementVNode("span", { class: "ia-stat-label" }, "Requisições totais", -1))
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("span", _hoisted_13, _toDisplayString($setup.formatTokens($setup.iaUsage.totalInputTokens)), 1),
                _cache[3] || (_cache[3] = _createElementVNode("span", { class: "ia-stat-label" }, "Tokens de entrada", -1))
              ]),
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("span", _hoisted_15, _toDisplayString($setup.formatTokens($setup.iaUsage.totalOutputTokens)), 1),
                _cache[4] || (_cache[4] = _createElementVNode("span", { class: "ia-stat-label" }, "Tokens de saída", -1))
              ]),
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("span", _hoisted_17, _toDisplayString($setup.formatCost($setup.avgCostPerRequest)), 1),
                _cache[5] || (_cache[5] = _createElementVNode("span", { class: "ia-stat-label" }, "Custo médio por requisição", -1))
              ])
            ]),
            _cache[8] || (_cache[8] = _createElementVNode("h4", {
              class: "ia-section-title",
              style: {"margin-top":"24px"}
            }, "Por recurso de IA", -1)),
            (!$setup.iaUsage.byResource || $setup.iaUsage.byResource.length === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_18, "Sem dados."))
              : (_openBlock(), _createElementBlock("div", _hoisted_19, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.iaUsage.byResource, (r) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: r.endpoint,
                      class: "ia-resource-row"
                    }, [
                      _createElementVNode("div", _hoisted_20, [
                        _createElementVNode("span", _hoisted_21, _toDisplayString(r.label), 1),
                        _createElementVNode("span", _hoisted_22, [
                          _createTextVNode(_toDisplayString($setup.formatCost(r.costUsd)) + " ", 1),
                          _createElementVNode("span", _hoisted_23, "(" + _toDisplayString(r.costSharePct) + "%)", 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_24, [
                        _createElementVNode("div", {
                          class: "ia-resource-bar",
                          style: _normalizeStyle({ width: Math.max(2, r.costSharePct) + '%' })
                        }, null, 4)
                      ]),
                      _createElementVNode("div", _hoisted_25, [
                        _createTextVNode(_toDisplayString(r.requests) + " req · " + _toDisplayString($setup.formatTokens(r.inputTokens)) + " entrada · " + _toDisplayString($setup.formatTokens(r.outputTokens)) + " saída ", 1),
                        (r.lastUsedAt)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_26, " · último uso " + _toDisplayString($setup.formatDate(r.lastUsedAt)), 1))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  }), 128))
                ])),
            _cache[9] || (_cache[9] = _createElementVNode("h4", {
              class: "ia-section-title",
              style: {"margin-top":"24px"}
            }, "Por dia (últimos 30 dias)", -1)),
            ($setup.iaUsage.byDay.length === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_27, "Sem dados."))
              : (_openBlock(), _createElementBlock("div", _hoisted_28, [
                  _createElementVNode("table", _hoisted_29, [
                    _cache[6] || (_cache[6] = _createElementVNode("thead", null, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("th", null, "Data"),
                        _createElementVNode("th", null, "Requisições"),
                        _createElementVNode("th", null, "Tokens entrada"),
                        _createElementVNode("th", null, "Tokens saída"),
                        _createElementVNode("th", null, "Custo est. (USD)")
                      ])
                    ], -1)),
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.iaUsage.byDay, (day) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: day.date
                        }, [
                          _createElementVNode("td", null, _toDisplayString($setup.formatDate(day.date)), 1),
                          _createElementVNode("td", null, _toDisplayString(day.requests), 1),
                          _createElementVNode("td", null, _toDisplayString($setup.formatTokens(day.inputTokens)), 1),
                          _createElementVNode("td", null, _toDisplayString($setup.formatTokens(day.outputTokens)), 1),
                          _createElementVNode("td", null, _toDisplayString($setup.formatCost(day.costUsd)), 1)
                        ]))
                      }), 128))
                    ])
                  ])
                ])),
            _cache[10] || (_cache[10] = _createElementVNode("h4", {
              class: "ia-section-title",
              style: {"margin-top":"24px"}
            }, "Últimas requisições", -1)),
            ($setup.iaUsage.recentLogs.length === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_30, "Sem requisições."))
              : (_openBlock(), _createElementBlock("div", _hoisted_31, [
                  _createElementVNode("table", _hoisted_32, [
                    _cache[7] || (_cache[7] = _createElementVNode("thead", null, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("th", null, "Data/Hora"),
                        _createElementVNode("th", null, "Recurso"),
                        _createElementVNode("th", null, "Tokens entrada"),
                        _createElementVNode("th", null, "Tokens saída"),
                        _createElementVNode("th", null, "Custo est.")
                      ])
                    ], -1)),
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.iaUsage.recentLogs, (log) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: log.id
                        }, [
                          _createElementVNode("td", null, _toDisplayString($setup.formatDateTime(log.createdAt)), 1),
                          _createElementVNode("td", {
                            title: log.endpoint
                          }, _toDisplayString(log.label || log.endpoint), 9, _hoisted_33),
                          _createElementVNode("td", null, _toDisplayString($setup.formatTokens(log.inputTokens)), 1),
                          _createElementVNode("td", null, _toDisplayString($setup.formatTokens(log.outputTokens)), 1),
                          _createElementVNode("td", null, _toDisplayString($setup.formatCost(log.costUsd ?? $setup.fallbackCost(log))), 1)
                        ]))
                      }), 128))
                    ])
                  ])
                ]))
          ], 64))
  ]))
}